import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHref } from 'react-router-dom';
import { remixerApi } from 'services/api/remixer';
import { locations } from 'services/routes/locations';
import { selectCurrentProjectId } from 'services/store/remixer/selectors';

const useSaveProject = () => {
  const projectId = useSelector(selectCurrentProjectId);

  const [saveProject, { isLoading, isSuccess }] =
    remixerApi.useSaveProjectMutation();

  const projectUrl = useHref(
    locations.studio.project.pathname(projectId || '')
  );

  const save = useCallback(() => saveProject().unwrap(), [saveProject]);

  useEffect(() => {
    if (isSuccess && projectId) {
      window.history.replaceState(null, '', projectUrl);
    }
  }, [isSuccess, projectId, projectUrl]);
  return {
    save,
    isLoading,
    isSuccess,
  };
};

export default useSaveProject;
